import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const RequirementSpecification = ({ 
  selectedCategory, 
  formData, 
  onFormDataChange, 
  errors 
}) => {
  const handleInputChange = (field, value) => {
    onFormDataChange({
      ...formData,
      [field]: value
    });
  };

  const renderCategorySpecificFields = () => {
    switch (selectedCategory?.id) {
      case 'consultancy':
        return (
          <div className="space-y-6">
            <Select
              label="Consultancy Type"
              placeholder="Select consultancy type"
              required
              options={[
                { value: 'it-strategy', label: 'IT Strategy & Planning' },
                { value: 'digital-transformation', label: 'Digital Transformation' },
                { value: 'business-analysis', label: 'Business Analysis' },
                { value: 'process-optimization', label: 'Process Optimization' },
                { value: 'technology-assessment', label: 'Technology Assessment' }
              ]}
              value={formData?.consultancyType}
              onChange={(value) => handleInputChange('consultancyType', value)}
              error={errors?.consultancyType}
            />
            <Input
              label="Current Challenges"
              type="text"
              placeholder="Describe your current business/technical challenges"
              value={formData?.currentChallenges}
              onChange={(e) => handleInputChange('currentChallenges', e?.target?.value)}
              error={errors?.currentChallenges}
              required
            />
            <Input
              label="Expected Outcomes"
              type="text"
              placeholder="What outcomes do you expect from this consultancy?"
              value={formData?.expectedOutcomes}
              onChange={(e) => handleInputChange('expectedOutcomes', e?.target?.value)}
              error={errors?.expectedOutcomes}
              required
            />
          </div>
        );

      case 'infrastructure':
        return (
          <div className="space-y-6">
            <Select
              label="Infrastructure Type"
              placeholder="Select infrastructure type"
              required
              options={[
                { value: 'server-setup', label: 'Server Setup & Configuration' },
                { value: 'cloud-migration', label: 'Cloud Migration' },
                { value: 'data-center', label: 'Data Center Solutions' },
                { value: 'virtualization', label: 'Virtualization' },
                { value: 'backup-recovery', label: 'Backup & Recovery' }
              ]}
              value={formData?.infrastructureType}
              onChange={(value) => handleInputChange('infrastructureType', value)}
              error={errors?.infrastructureType}
            />
            <Input
              label="Current Infrastructure"
              type="text"
              placeholder="Describe your current infrastructure setup"
              value={formData?.currentInfrastructure}
              onChange={(e) => handleInputChange('currentInfrastructure', e?.target?.value)}
              error={errors?.currentInfrastructure}
              required
            />
            <Input
              label="Expected Users/Load"
              type="number"
              placeholder="Number of concurrent users expected"
              value={formData?.expectedLoad}
              onChange={(e) => handleInputChange('expectedLoad', e?.target?.value)}
              error={errors?.expectedLoad}
              required
            />
          </div>
        );

      case 'networking':
        return (
          <div className="space-y-6">
            <Select
              label="Network Solution Type"
              placeholder="Select network solution type"
              required
              options={[
                { value: 'lan-setup', label: 'LAN Setup & Configuration' },
                { value: 'wifi-deployment', label: 'WiFi Deployment' },
                { value: 'network-security', label: 'Network Security' },
                { value: 'wan-connectivity', label: 'WAN Connectivity' },
                { value: 'network-monitoring', label: 'Network Monitoring' }
              ]}
              value={formData?.networkType}
              onChange={(value) => handleInputChange('networkType', value)}
              error={errors?.networkType}
            />
            <Input
              label="Coverage Area"
              type="text"
              placeholder="Describe the area to be covered (sq ft, floors, etc.)"
              value={formData?.coverageArea}
              onChange={(e) => handleInputChange('coverageArea', e?.target?.value)}
              error={errors?.coverageArea}
              required
            />
            <Input
              label="Number of Devices"
              type="number"
              placeholder="Estimated number of devices to connect"
              value={formData?.deviceCount}
              onChange={(e) => handleInputChange('deviceCount', e?.target?.value)}
              error={errors?.deviceCount}
              required
            />
          </div>
        );

      case 'software':
        return (
          <div className="space-y-6">
            <Select
              label="Software Solution Type"
              placeholder="Select software solution type"
              required
              options={[
                { value: 'custom-development', label: 'Custom Software Development' },
                { value: 'web-application', label: 'Web Application' },
                { value: 'mobile-app', label: 'Mobile Application' },
                { value: 'erp-system', label: 'ERP System' },
                { value: 'crm-system', label: 'CRM System' }
              ]}
              value={formData?.softwareType}
              onChange={(value) => handleInputChange('softwareType', value)}
              error={errors?.softwareType}
            />
            <Input
              label="Functional Requirements"
              type="text"
              placeholder="Describe the key features and functionality needed"
              value={formData?.functionalRequirements}
              onChange={(e) => handleInputChange('functionalRequirements', e?.target?.value)}
              error={errors?.functionalRequirements}
              required
            />
            <Select
              label="Platform Preference"
              placeholder="Select preferred platform"
              options={[
                { value: 'web-based', label: 'Web-based' },
                { value: 'desktop', label: 'Desktop Application' },
                { value: 'mobile', label: 'Mobile Application' },
                { value: 'cross-platform', label: 'Cross-platform' }
              ]}
              value={formData?.platformPreference}
              onChange={(value) => handleInputChange('platformPreference', value)}
              error={errors?.platformPreference}
            />
          </div>
        );

      case 'policy':
        return (
          <div className="space-y-6">
            <Select
              label="Policy Area"
              placeholder="Select policy area"
              required
              options={[
                { value: 'it-governance', label: 'IT Governance' },
                { value: 'data-protection', label: 'Data Protection & Privacy' },
                { value: 'cybersecurity', label: 'Cybersecurity Policy' },
                { value: 'compliance', label: 'Regulatory Compliance' },
                { value: 'risk-management', label: 'Risk Management' }
              ]}
              value={formData?.policyArea}
              onChange={(value) => handleInputChange('policyArea', value)}
              error={errors?.policyArea}
            />
            <Input
              label="Current Policy Status"
              type="text"
              placeholder="Describe your current policy framework (if any)"
              value={formData?.currentPolicyStatus}
              onChange={(e) => handleInputChange('currentPolicyStatus', e?.target?.value)}
              error={errors?.currentPolicyStatus}
              required
            />
            <Input
              label="Compliance Requirements"
              type="text"
              placeholder="Any specific compliance standards you need to meet"
              value={formData?.complianceRequirements}
              onChange={(e) => handleInputChange('complianceRequirements', e?.target?.value)}
              error={errors?.complianceRequirements}
            />
          </div>
        );

      case 'strategy':
        return (
          <div className="space-y-6">
            <Select
              label="Strategy Focus"
              placeholder="Select strategy focus area"
              required
              options={[
                { value: 'digital-strategy', label: 'Digital Strategy' },
                { value: 'it-roadmap', label: 'IT Roadmap Planning' },
                { value: 'technology-adoption', label: 'Technology Adoption' },
                { value: 'innovation-strategy', label: 'Innovation Strategy' },
                { value: 'change-management', label: 'Change Management' }
              ]}
              value={formData?.strategyFocus}
              onChange={(value) => handleInputChange('strategyFocus', value)}
              error={errors?.strategyFocus}
            />
            <Input
              label="Business Objectives"
              type="text"
              placeholder="Describe your key business objectives"
              value={formData?.businessObjectives}
              onChange={(e) => handleInputChange('businessObjectives', e?.target?.value)}
              error={errors?.businessObjectives}
              required
            />
            <Input
              label="Timeline for Implementation"
              type="text"
              placeholder="When do you plan to implement the strategy?"
              value={formData?.implementationTimeline}
              onChange={(e) => handleInputChange('implementationTimeline', e?.target?.value)}
              error={errors?.implementationTimeline}
              required
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-foreground mb-2">Requirement Specification</h2>
        <p className="text-muted-foreground">
          Provide detailed requirements for your {selectedCategory?.name} solution
        </p>
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name={selectedCategory?.icon} size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{selectedCategory?.name}</h3>
            <p className="text-sm text-muted-foreground">{selectedCategory?.description}</p>
          </div>
        </div>

        <div className="space-y-6">
          <Input
            label="Project Title"
            type="text"
            placeholder="Give your project a descriptive title"
            value={formData?.projectTitle}
            onChange={(e) => handleInputChange('projectTitle', e?.target?.value)}
            error={errors?.projectTitle}
            required
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Project Description *
            </label>
            <textarea
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
              rows={4}
              placeholder="Provide a detailed description of your project requirements"
              value={formData?.projectDescription}
              onChange={(e) => handleInputChange('projectDescription', e?.target?.value)}
            />
            {errors?.projectDescription && (
              <p className="mt-1 text-sm text-error">{errors?.projectDescription}</p>
            )}
          </div>

          {renderCategorySpecificFields()}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Select
              label="Priority Level"
              placeholder="Select priority level"
              required
              options={[
                { value: 'low', label: 'Low - Can wait 3+ months' },
                { value: 'medium', label: 'Medium - Needed within 2-3 months' },
                { value: 'high', label: 'High - Needed within 1 month' },
                { value: 'urgent', label: 'Urgent - Needed ASAP' }
              ]}
              value={formData?.priorityLevel}
              onChange={(value) => handleInputChange('priorityLevel', value)}
              error={errors?.priorityLevel}
            />

            <Select
              label="Project Size"
              placeholder="Select project size"
              required
              options={[
                { value: 'small', label: 'Small - Under $5,000' },
                { value: 'medium', label: 'Medium - $5,000 - $20,000' },
                { value: 'large', label: 'Large - $20,000 - $50,000' },
                { value: 'enterprise', label: 'Enterprise - $50,000+' }
              ]}
              value={formData?.projectSize}
              onChange={(value) => handleInputChange('projectSize', value)}
              error={errors?.projectSize}
            />
          </div>

          <div className="space-y-4">
            <label className="block text-sm font-medium text-foreground">
              Additional Requirements
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Checkbox
                label="Training Required"
                checked={formData?.trainingRequired}
                onChange={(e) => handleInputChange('trainingRequired', e?.target?.checked)}
              />
              <Checkbox
                label="Ongoing Support Needed"
                checked={formData?.ongoingSupport}
                onChange={(e) => handleInputChange('ongoingSupport', e?.target?.checked)}
              />
              <Checkbox
                label="Documentation Required"
                checked={formData?.documentationRequired}
                onChange={(e) => handleInputChange('documentationRequired', e?.target?.checked)}
              />
              <Checkbox
                label="Integration with Existing Systems"
                checked={formData?.integrationRequired}
                onChange={(e) => handleInputChange('integrationRequired', e?.target?.checked)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequirementSpecification;